// @ts-nocheck
import { LazyImageStyle } from "@insite/mobius/LazyImage";
import { StyledImgWrapper } from "@store/MobiusOverrides/Img/Img";
import { css } from "styled-components";

export const imageStyles = (ratio: number) => {
    return css`
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;

        &::before {
            content: "";
            display: block;
            padding-top: ${ratio * 100}%;
        }

        ${LazyImageStyle}, ${StyledImgWrapper} {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                width: auto;
                height: auto;
                min-width: 0;
                min-height: 0;
                max-width: 100%;
                max-height: 100%;
            }
        }
    `;
};
